module.exports = __webpack_public_path__ + "img/casino-dream.fb46fb85.jpg";